// Copyright (c) 2018 Deere & Company

export const isEditable = partRequest => {

    const editableStatuses = ['1', '5', '6', '7'];

    return editableStatuses.includes(partRequest.returnStatus.id);

};

export const noPartsReturned = '7';



// WEBPACK FOOTER //
// ./src/part-requests/request-details/services/return-status.js